<template>
  <PublicPopup
    ref="PopupRef"
    type="fullScreen"
    position="center"
    :height="100"
    :padding="0"
    :closeable="false"
    :overlay-style="goldCoinsOverlayStyle"
    @close="handlePopupCloseEmit"
  >
    <template #content>
      <div class="gold-coins-burst-popup">
        <div class="popup-scroll">
          <div class="popup-content">
            <GoldCoinsBurst
              ref="BurstRef"
              embedded
              :autoplay="false"
              @deposito="handleDeposito"
            />

            <div class="checkbox-wrap">
              <CheckboxPublic type="gold-coins-burst" />
            </div>

            <div class="close-container chxy-row-c-c" @click="handlePopupClose">
              <van-icon name="close" size="32" color="#FFFFFF" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const route = useRoute()

const GoldCoinsBurstPopupChecked = ref(
  window.localStorage.GoldCoinsBurstPopupChecked || 'null'
)

const PopupRef = ref(null)
const BurstRef = ref(null)

const goldCoinsOverlayStyle = {
  backgroundColor: 'var(--van-overlay-background)',
}

const open = () => {
  if (GoldCoinsBurstPopupChecked.value === 'checked') return false

  if ( route.name === 'Home') {
    nextTick(() => {
      PopupRef.value.open()

      nextTick(() => {
        BurstRef.value?.reset()
        BurstRef.value?.play()
      })
    })
  }
}

const handlePopupClose = () => {
  BurstRef.value?.stop()
  PopupRef.value.close()
}

const handlePopupCloseEmit = () => {
  BurstRef.value?.stop()
  emit('close')
}

const handleDeposito = () => {
  handlePopupClose()
  emit('deposito')
}

const emit = defineEmits(['close', 'deposito'])

defineExpose({
  open,
})
</script>

<style lang="less" scoped>
.gold-coins-burst-popup {
  position: relative;
  width: 100%;
  height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  pointer-events: none;
}

.popup-scroll {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: max(12px, env(safe-area-inset-top)) 0 max(28px, env(safe-area-inset-bottom));
}

.popup-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(375px, 100vw);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.checkbox-wrap {
  position: relative;
  width: 100%;
  margin-top: 0px;
  z-index: 10;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: none;
  left: auto;
  top: auto;
}

.close-container {
  position: relative;
  width: 44px;
  height: 44px;
  margin-top: 14px;
  margin-bottom: 18px;
  z-index: 10;
  pointer-events: auto;
  transform: none;
  left: auto;
  top: auto;
}
</style>
